@if (!isGlobal || (spinnerOn$ | async)) {
  <div class="spinner">
    <div class="loaderContainer">
      <ng-lottie width="500" [options]="lottieConfig"></ng-lottie>
    </div>
  </div>
}
